import React, { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from "@/components/ui/dialog";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ChangePasswordDialog({ open, onOpenChange }) {
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [conf, setConf] = useState("");
  const [saving, setSaving] = useState(false);

  const reset = () => { setCur(""); setNw(""); setConf(""); };

  const submit = async (e) => {
    e.preventDefault();
    if (nw.length < 6) return toast.error("Password baru minimal 6 karakter");
    if (nw !== conf) return toast.error("Konfirmasi password tidak cocok");
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: nw });
      toast.success("Password berhasil diubah");
      reset();
      onOpenChange(false);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) reset(); onOpenChange(o); }}>
      <DialogContent>
        <DialogHeader><DialogTitle className="font-heading">Ganti Password</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4 mt-1">
          <div className="space-y-2">
            <Label>Password Saat Ini</Label>
            <Input type="password" value={cur} onChange={(e) => setCur(e.target.value)} data-testid="current-password-input" required className="rounded-xl" />
          </div>
          <div className="space-y-2">
            <Label>Password Baru</Label>
            <Input type="password" value={nw} onChange={(e) => setNw(e.target.value)} data-testid="new-password-input" required className="rounded-xl" placeholder="Minimal 6 karakter" />
          </div>
          <div className="space-y-2">
            <Label>Ulangi Password Baru</Label>
            <Input type="password" value={conf} onChange={(e) => setConf(e.target.value)} data-testid="confirm-password-input" required className="rounded-xl" />
          </div>
          <DialogFooter>
            <Button type="submit" disabled={saving} data-testid="submit-change-password" className="bg-emerald-600 hover:bg-emerald-700 rounded-xl">
              {saving ? <Loader2 className="animate-spin" /> : "Simpan Password Baru"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
